<template>
    <content-layout>
        <template #header>Home Page</template>
        <template #description>The "about us" text on the website's home page.</template>

        <el-form ref="form" label-position="top">
            <el-form-item label="Title">
                <el-input v-model="siteContent.homePageAboutTitle"></el-input>
            </el-form-item>
            <el-form-item label="Paragraph 1">
                <el-input type="textarea" :autosize="{minRows: 3, maxRows: 12}" v-model="siteContent.homePageAboutParagraphOne"></el-input>
            </el-form-item>
            <el-form-item label="Paragraph 2">
                <el-input type="textarea" :autosize="{minRows: 3, maxRows: 12}" v-model="siteContent.homePageAboutParagraphTwo"></el-input>
            </el-form-item>
            <el-form-item label="Paragraph 3">
                <el-input type="textarea" :autosize="{minRows: 3, maxRows: 12}" v-model="siteContent.homePageAboutParagraphThree"></el-input>
            </el-form-item>
            <div class="form-actions">
                <el-button type="primary" :loading="submitButtonLoading" @click="onSubmit">Save</el-button>
            </div>
        </el-form>
    </content-layout>
</template>

<script>

    import siteContentAPI from "../mixins/api/siteContentAPI";

    export default {
        name: "HomePage",
        mixins: [siteContentAPI],
        data() {
            return {
                
                siteContentID: '',
                siteContent: {},

                submitButtonLoading: false

            }
        },

        beforeMount: async function() {
            this.siteContent = await this.getSiteContent();
            this.loading = false;
        },

        methods: {

            async onSubmit() {


                try {

                    this.submitButtonLoading = true;

                    await this.patchSiteContent(this.siteContent);

                    this.getSiteContent();

                    this.submitButtonLoading = false;

                    this.$notify({
                        message: 'Saved.',
                        type: 'success'
                    });

                } catch (error) {
                    this.submitButtonLoading = false;

                    this.$notify({
                        message: `${error}`,
                        type: 'error'
                    });
                }

            }
        }
    }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/site-content/HomePage.vue